// React Router: App.tsx stays the layout (header and page frame), the pages
// are its children. The News area lives at /news and keeps its state in the
// query string (src/features/news/params.ts):
//   /news?tab=latest|feed|saved&sources=…&months=…&weeks=…&feed=…
// A news in its own page is /news/:origin/:id (the id percent-encoded: Coro's
// carry colons); a sibling of /news, so the header keeps News active.
// The Parliament lives in Ultime news: /parlamento goes to the view of the
// four sources of sittings (/news?sources=…), a sitting is at
// /parlamento/:chamber/:sessionType/:number (a sibling of /news as well).
// /ricerca and /alert are the sections in development.
// /guida is the guide, opened from the user menu; it belongs to no section of the header.
// /accesso (?esito=<code>) is where Loggione's callback sends a sign-in that ended for a reason the
// person can act on; it sits beside App, not under it.
import { createBrowserRouter, createMemoryRouter, redirect, type InitialEntry, type RouteObject } from "react-router";

import App from "../App";
import { AccessPage } from "../pages/AccessPage";
import { GuidePage } from "../pages/GuidePage";
import { AlertPage, RicercaPage } from "../pages/InDevelopmentPages";
import { NewsItemPage } from "../pages/NewsItemPage";
import { NewsPage } from "../pages/NewsPage";
import { SittingPage } from "../pages/SittingPage";
import { SITTINGS_VIEW_PATH } from "../features/parliament/adapt";

export const routes: RouteObject[] = [
  // The page of a refused or failed sign-in: outside App on purpose (no /me, no header, no redirect).
  { path: "/accesso", Component: AccessPage },
  {
    path: "/",
    Component: App,
    children: [
      { index: true, loader: () => redirect("/news") },
      { path: "news", Component: NewsPage },
      { path: "news/:origin/:id", Component: NewsItemPage },
      { path: "ricerca", Component: RicercaPage },
      { path: "alert", Component: AlertPage },
      { path: "parlamento", loader: () => redirect(SITTINGS_VIEW_PATH) },
      { path: "parlamento/:chamber/:sessionType/:number", Component: SittingPage },
      { path: "guida", Component: GuidePage },
      { path: "*", loader: () => redirect("/news") },
    ],
  },
];

export function browserRouter() {
  return createBrowserRouter(routes);
}

/** For tests: the same routes on an in-memory history (an entry may carry a location state). */
export function memoryRouter(initialEntries: InitialEntry[]) {
  return createMemoryRouter(routes, { initialEntries });
}
